import styled from "styled-components";
import {Container, Text1} from "../../../../styles/business-components";

export const InfoContainer = styled(Container)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    gap: 40px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 70px 200px;
    gap: 70px;
  }
`

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    width: 300px;
    
    @media only screen and (${({theme}) => theme.media.ultraLarge}) {
      width: 400px;
    }
    
    #text {
      color: ${({theme}) => theme.business.colors.textColor};
    }
  }
`

export const TextBlock1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.medium}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    gap: 40px;
  }
`

export const Text = styled(Text1)`
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`

export const Image = styled.img`
  width: 100%;
  height: auto;
  filter: grayscale(100%);
`